import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncTopUpAmount = loadable(() => import('./TopUpAmount'), {
  fallback: <Loader />,
});
